package kz.dentalcrm.app.data.network.request_model

import kotlinx.serialization.Serializable

@Serializable
data class AddPatientBody(
    val phone: String?,
    val name: String?,
    val surname: String?,
    val patronymic: String = "  ",
)